import React from 'react'
import FormCarouselSettings from 'components/forms/image/FormCarouselSettings'

const ImageCarouselSettings = ({
  valueSettings,
  onChangeSettings,
}) => {
  return (
    <FormCarouselSettings
      value={valueSettings}
      onChange={onChangeSettings}
    />
  )
}

export default ImageCarouselSettings



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/imageCarousel/ImageCarouselSettings.js